import { useContext } from 'react';
import { ApiContext } from '../context';

export function useApi() {
  const context = useContext(ApiContext);
  return { ...context };
}
